/* eslint-disable */
import da from 'date-fns/esm/locale/da/index.js';
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
  GetAllGroups,
  GetFactoriesByGroupID,
  createQRtag,
  saveQRtags,
};

async function GetAllGroups() {
  const response = await CommonGet('/api/Group/GetAllGroups', null);
  return response.data;
}

async function GetFactoriesByGroupID(groupID) {
  const response = await CommonGet(
    '/api/Factory/GetFactoriesByGroupID',
    'groupID=' + parseInt(groupID)
  );
  return response.data;
}
async function createQRtag(model) {
  const response = await CommonPost('/api/QRTag/CreateQRtag', null, model);
  return response.data;
}
async function saveQRtags(data) {
  const response = await CommonPost('/api/QRtag/SaveQRtag', null, data);
  return response;
}
